import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { BaseMenuItemProps } from '..'
import { styles } from '../../../../utilities'

export default (config: {
  props: Pick<BaseMenuItemProps, 'disabled' | 'fileInput' | 'selected'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      content: {
        alignItems: 'center',
        border: 0,
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        fontWeight: props.selected ? 600 : 'undefined',
        display: 'flex',
        position: 'relative',
        textAlign: 'start',
        textDecoration: 'none',
        transitionProperty: 'background-color',
        transitionDuration: '0.1s',
        transitionTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',

        ...(!props.disabled && {
          '&:hover': {
            color: 'inherit',
            textDecoration: 'none',
          },

          '&:active': {
            color: 'inherit',
            textDecoration: 'none',
          },
        }),

        ...(props.fileInput
          ? CreateFocusCss(
              tokens.focusInner,
              (pseudoClass: string) => `input${pseudoClass} + &`,
            )
          : CreateFocusCss(tokens.focusInner)),

        '@media (hover: none)': {
          minHeight: '40px',
        },
      },

      startElement: {
        alignItems: 'center',
        display: 'flex',
        fill: 'currentColor',
        flex: '0 0 auto',
      },

      endElement: {
        ...tokens.fontBodyM,
        alignItems: 'center',
        display: 'flex',
        fill: 'currentColor',
        flex: '0 0 auto',
        marginInlineStart: '12px',
      },

      checkmarkElement: {
        display: 'flex',
        alignItems: 'flex-end',
        marginInlineStart: tokens.spacingGap100,
        width: tokens.iconSizeM,
      },

      text: {
        flex: '1 1 auto',
        background: props.disabled ? 'transparent' : undefined,
        color: props.disabled ? tokens.fontColorDisabled : undefined,
      },

      description: {
        ...tokens.fontDetailS,
        color: props.disabled
          ? tokens.fontColorDisabled
          : tokens.fontColorSubtle,
        display: 'block',
        background: props.disabled ? 'transparent' : undefined,
      },

      badge: {
        position: 'relative',
        insetInlineEnd: '-5px',
      },
    },

    selectedOption: {
      iconWrap: {
        display: 'flex',
        fill: tokens.iconColorDefault,
        flex: '0 0 auto',

        width: tokens.iconSizeM,
        color: props.disabled ? tokens.iconColorDisabled : undefined,
      },
    },

    motionVariants: {
      default: {
        initial: {
          opacity: 0,
        },
        open: {
          opacity: 1,
          transition: {
            ease: 'harmonize',
            duration: 0.15,
          },
        },
      },
    },

    hidden: styles.visuallyHidden,
  } as const
}
